import { OnboardCardTemplate, OnboardCardTemplateProps } from "./template";

export type OnboardCardProps = OnboardCardTemplateProps;

export const OnboardCard = (props: OnboardCardProps): JSX.Element => {
  return <OnboardCardTemplate {...props} />;
};
